import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { MenuConfigService } from '../menu-config.service';
import { ClassInitService } from '../class-init.service';
import * as objectPath from 'object-path';
import { LayoutConfigService } from "../layout-config.service";

@Injectable()
export class MenuAsideService {
	classes: string;
	menuList$: BehaviorSubject<any[]> = new BehaviorSubject([]);

	isDropdown: number = 0;
	dropdownTimeout: number;
	isScrollable: number = 0;

	constructor(
		private menuConfigService: MenuConfigService,
		private classInitService: ClassInitService,
		private layoutConfigService: LayoutConfigService
	) {
		// get menu list
		this.menuConfigService.onMenuUpdated$.subscribe(model => {
			setTimeout(() =>{
				var items = objectPath.get(model.config, 'aside.items');
				// Filter out staffRestricted items for Sales Person users
				var filteredItems = this.filterMenuItems(items);
				this.menuList$.next(filteredItems);
			});
		});

		this.layoutConfigService.onLayoutConfigUpdated$.subscribe(config => {
			if (objectPath.get(config, 'config.aside.left.fixed')) {
				this.isScrollable = 1;
				this.isDropdown = 0;
			}

			if (!objectPath.get(config, 'config.aside.left.fixed') && !objectPath.get(config, 'config.menu.aside.desktop_and_mobile.submenu.accordion')) {
				this.isScrollable = 0;
				this.isDropdown = 1;
				this.dropdownTimeout = objectPath.get(config, 'config.menu.aside.desktop_and_mobile.submenu.dropdown.hover_timeout');
			}
		});
	}

	private filterMenuItems(items: any[]): any[] {
		if (!items) {
			return [];
		}
		// A staff login keeps only the items marked staffAllowed.
		if (localStorage.getItem('staff_restricted') === '1') {
			var keepAllowed = function(list: any[]): any[] {
				return list
					.map(function(item) {
						if (!item.submenu) {
							return item;
						}
						return Object.assign({}, item, { submenu: keepAllowed(item.submenu) });
					})
					.filter(function(item) {
						return item.staffAllowed || (item.submenu && item.submenu.length > 0);
					});
			};
			return keepAllowed(items);
		}
		var isSalesPerson = this.checkIsSalesPerson();
		if (!isSalesPerson) {
			return items;
		}
		// Filter out items marked as staffRestricted for sales person users,
		// including items nested inside a group; drop a group left empty
		var filterLevel = function(list: any[]): any[] {
			return list
				.filter(function(item) {
					return !item.staffRestricted;
				})
				.map(function(item) {
					if (!item.submenu) {
						return item;
					}
					return Object.assign({}, item, { submenu: filterLevel(item.submenu) });
				})
				.filter(function(item) {
					return !item.submenu || item.submenu.length > 0;
				});
		};
		return filterLevel(items);
	}

	private checkIsSalesPerson(): boolean {
		var rolesStr = localStorage.getItem('staff_roles');
		if (!rolesStr) {
			return false;
		}
		try {
			var roles = JSON.parse(rolesStr);
			return roles.indexOf('sales_person') > -1 && roles.indexOf('account_manager') === -1;
		} catch (e) {
			return false;
		}
	}
}
